import React from 'react';
import { Pressable, Image, StyleSheet } from 'react-native';
import { COLOR } from '../../../constants/styles';
import OPComponent from '../op_component';

export default class RemoveButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { onPress } = this.props;
    return (
      <Pressable onPress={this.props.onPress} style={styles.btn}>
        <Image
          style={styles.checkIcon}
          source={require('../../../../resources/close-orange.png')}
        />
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  btn: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
    borderColor: COLOR.error,
    borderWidth: 1.5,
    borderRadius: 15,
    backgroundColor: 'white',
  },
  checkIcon: {
    width: 13,
    height: 13,
  },
});
